export const arrowUpPath = "<path d=\"M8 13 V3 M4 7 L8 3 L12 7\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
